<router-outlet></router-outlet>

@if (!firstNavigationDone()) {
  <app-loading-screen [failed]="startupFailed()" [failAfterMs]="stuckAfterMs" />
}

<app-site-search></app-site-search>
<app-redirect-screen></app-redirect-screen>
<app-download-indicator></app-download-indicator>